import React, { useState } from "react"
import Modal from "../Modal"
import "./imageinput.css"
import autzuSummer from "../../../images/blogsPreselected/autzusummer.jpeg"
import uberRent from "../../../images/blogsPreselected/uberrent.jpg"
import uberRent2 from "../../../images/blogsPreselected/uberrent2.png"
import uberRent3 from "../../../images/blogsPreselected/uberrent3.png"
import autzuCalendar from "../../../images/blogsPreselected/autzucalendar.png"
import { selectedSrc } from '../../../utils';


const PreselectedImages = ({open, toggle, text, setFile}) => {

    const [selectedImage,setSelectedImage] = useState();

    const imageUploader = () => {
        var output = document.getElementById(`file-input-${text}`).files[0];
        setSelectedImage(output);
        output.src = URL.createObjectURL(output);
        output.onload = function () {
            URL.revokeObjectURL(output.src);
        };
    };

    const fetchFile = async (url) => {
    try {
        const response = await fetch(url);
    
        if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
        }
        const blob = await response.blob();
        const file = new File([blob], url, { type: blob.type});
        console.log(file)

        return file;
    } catch (error) {
        console.error('Error fetching the file:', error);
        return null;
    }
    };

    const SelectableImage = ({url}) => {
        return(
            <img className='preselectedImage' src={url} onClick={()=>{fetchFile(url).then(file=> {
                if (file) {
                    setSelectedImage(file);
                }
            })}}/>
        )
    }

    return(
        <Modal open={open}
        padding="0"
        width="0">
            <div className="preselectedModal">
                <div className='preselectedHeader'>Select Image</div>
                Recommended minimum resolution 720px x 320px.
                <div className='preselectedCatalog'>
                    <SelectableImage url={autzuSummer}/>
                    <SelectableImage url={uberRent}/>
                    <SelectableImage url={uberRent2}/>
                    <SelectableImage url={uberRent3}/>
                    <SelectableImage url={autzuCalendar}/>
                </div>

                <label for={`file-input-${text}`} className="uploadButton">
                    Upload Picture
                </label>
                <img className={selectedImage?'selectedImage':''} src={selectedSrc(selectedImage)}/>

                <input
                    id={`file-input-${text}`}
                    className="uploadButton"
                    type="file"
                    accept="image/*"
                    onChange={imageUploader}
                    style={{display:'none'}} //css doesnt work
                    onClick={(e) => (e.target.value = null)}
                />
                <div className='buttonFooter'>
                    <div className='deleteBlogButton' onClick={toggle}>Cancel</div>
                    <div className='deleteBlogButton' style={{color:'#128DFF'}} onClick={() => {
                        setFile(selectedImage);
                        toggle();
                    }}>Save</div>
                </div>
            </div>

        </Modal>
    )
}

export default PreselectedImages;


// WEBPACK FOOTER //
// ./src/components/shared/ImageInput/PreselectedImages.js